export interface OpsContractorsListView {
  name: string;
  reportingManager: string;
  status: string;
  sowExpiry: string;
  doj: string;
  location: string;
  totalExp: string;
  vendor: string;
  rto: string;
  jobTitle: string;
  employeeId: string;
}

export const columnDefs = [
  {
    headerName: 'Contractor Name',
    field: 'name',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'Reporting Manager',
    field: 'reportingManager',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'Status',
    field: 'status',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'SOW Expiry',
    field: 'sowExpiry',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'DOJ',
    field: 'doj',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'Vendor',
    field: 'vendor',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'Location',
    field: 'location',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'Total Exp.',
    field: 'totalExp',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
  {
    headerName: 'RTO',
    field: 'rto',
    sortParams: { enabled: true },
    filterParams: { hideMenu: true },
  },
];
